import type { ReactNode } from "react";
import { cn } from "@/ui/foundation/lib/utils";

interface KeyValueRowProps {
    label: ReactNode;
    value: ReactNode;
    className?: string;
}

export function KeyValueRow({ label, value, className }: KeyValueRowProps) {
    return (
        <div className={cn("flex items-center justify-between", className)}>
            <span>{label}</span>
            {value}
        </div>
    );
}

type InfoCalloutTone = "muted" | "primary";

interface InfoCalloutProps {
    children: ReactNode;
    tone?: InfoCalloutTone;
    className?: string;
}

const calloutClassByTone: Record<InfoCalloutTone, string> = {
    muted: "rounded-md border bg-muted/30 p-3 text-xs text-muted-foreground",
    primary: "rounded-md border border-primary/25 bg-primary/5 px-3 py-2 text-xs text-muted-foreground",
};

export function InfoCallout({ children, tone = "muted", className }: InfoCalloutProps) {
    return (
        <div className={cn(calloutClassByTone[tone], className)}>
            {children}
        </div>
    );
}
